import { render, staticRenderFns } from "./CrmGroupCreate.vue?vue&type=template&id=1e04f942&scoped=true&"
import script from "./CrmGroupCreate.vue?vue&type=script&lang=ts&"
export * from "./CrmGroupCreate.vue?vue&type=script&lang=ts&"
import style0 from "./CrmGroupCreate.vue?vue&type=style&index=0&id=1e04f942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04f942",
  null
  
)

export default component.exports